import React from 'react';
import { motion } from 'framer-motion';
export function RevelationSection() {
  return <section className="bg-charcoal text-cream py-20 md:py-32 px-4 relative overflow-hidden" data-id="element-102">
      {/* Decorative subtle background lines */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#D4A843 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-103" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-105">
          <h2 className="text-3xl md:text-5xl font-serif text-gold mb-10 text-center" data-id="element-106">
            La Revelación
          </h2>

          <div className="space-y-8 text-lg md:text-xl text-cream/90 leading-relaxed" data-id="element-107">
            <p data-id="element-108">
              La razón por la que no has avanzado no es por falta de fe. Es por
              falta de un Blueprint (Plano).
            </p>

            <blockquote className="text-2xl md:text-3xl font-serif text-gold text-center py-8 border-y border-gold/20 my-10" data-id="element-109">
              "Dios dividió el Mar Rojo, pero Moisés tuvo que caminar."
            </blockquote>

            <p data-id="element-110">Tu negocio necesita esa misma combinación:</p>

            <div className="bg-gold/10 border border-gold/30 p-6 rounded-sm text-center my-8" data-id="element-111">
              <span className="text-xl md:text-2xl font-serif text-gold" data-id="element-112">
                Obediencia Espiritual + Excelencia Empresarial
              </span>
            </div>

            <p data-id="element-113">
              He condensado años de experiencia en negocios en EE.UU. y
              principios bíblicos innegociables para crear el sistema{' '}
              <strong className="text-gold font-serif text-2xl" data-id="element-114">
                "Emprender con Unción"
              </strong>
              . Un método diseñado para el hispano que vive aquí, que entiende
              la economía americana, pero que no está dispuesto a negociar su fe
              por un dólar.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}